import React, { useContext } from 'react';

import DraftManualDetailProvider, { DraftManualDetailContext } from './context';
import DraftManualsDetailPage from './Page';
import { SharedTrackChangesContext } from 'components/ContentEditor/context/SharedTrackChangesContext';
import AttachmentLibrary from './AttachmentLibrary';

const DraftManualsDetailContent: React.FC = () => {
  const { isAttachmentLibraryOpen, setIsAttachmentLibraryOpen } = useContext(DraftManualDetailContext);

  return (
    <>
      <DraftManualsDetailPage />
      <AttachmentLibrary
        open={isAttachmentLibraryOpen}
        onCancel={() => setIsAttachmentLibraryOpen(false)}
      />
    </>
  );
};

const DraftManualsDetail: React.FC = () => {
  return (
    <DraftManualDetailProvider>
      <SharedTrackChangesContext>
        <DraftManualsDetailContent />
      </SharedTrackChangesContext>
    </DraftManualDetailProvider>
  );
};

export default DraftManualsDetail;
